<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2">Dedication</h2>
<p class="normal">With love to Bryan, Otto, and my mom. And to my dad, who reminded me after a string of screen exposure failures, “If it were easy, everyone would be doing it.”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781607056188_03_ded.vue?a95ec638